import { Event } from "../types";

export function parseEventDate(dateString: string): Date {
  const [day, month, year] = dateString.split('.').map(Number);
  return new Date(year, month - 1, day);
}

export function isEventPast(eventDate: Date): boolean {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  eventDate.setHours(0, 0, 0, 0);
  return eventDate < today;
}

export function categorizeEvents(events: Event[]) {
  const upcoming: Event[] = [];
  const past: Event[] = [];

  if (!events || !Array.isArray(events)) {
    return { upcoming, past };
  }

  events.forEach((event) => {
    const eventDate = parseEventDate(event.date);
    if (isEventPast(eventDate)) {
      past.push(event);
    } else {
      upcoming.push(event);
    }
  });

  // Sort upcoming events by date (earliest first)
  upcoming.sort((a, b) => parseEventDate(a.date).getTime() - parseEventDate(b.date).getTime());

  // Sort past events by date (most recent first)
  past.sort((a, b) => parseEventDate(b.date).getTime() - parseEventDate(a.date).getTime());

  return { upcoming, past };
}

/**
 * Converts DD.MM.YYYY to YYYY-MM-DD
 */
export function toHtmlDate(dateString: string): string {
  if (!dateString) return "";
  const parts = dateString.split('.');
  if (parts.length !== 3) return "";
  return `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
}

/**
 * Converts YYYY-MM-DD to DD.MM.YYYY
 */
export function fromHtmlDate(dateString: string): string {
  if (!dateString) return "";
  const parts = dateString.split('-');
  if (parts.length !== 3) return "";
  return `${parts[2]}.${parts[1]}.${parts[0]}`;
}
